import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

/**
 * OAuth scopes are platform-wide catalog rows without a client, so only the global `*_any`
 * operations exist (mirrors the backend OAuthScopeVoter). The catalog is read only over the API,
 * so reading is the only check the frontend needs.
 */
export class OAuthScopeVoter extends ContextVoter {
  public canRead = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationOauthscopeReadany,
    });
  };
}
